import {workingSet} from './mergeContext';
import store from '../store';
import Actions from '../actions/indexExport';
import {getCurrentUserId} from '../../lib/picos/currentLogin';
import newHRTimestamp from '../../lib/picos/timestamp';
import {findAll} from '../find';
import ImportExport from '../../entities/importExport';
import {canCascadeDelete, addDeleteImpact, deleteImpactContext, deleteImpactCounts, workingRows, enqueueDelete} from './deleteContext';
import type {DeleteImpact, DeleteImpactContext, DeleteResult, DeleteTraversal} from './deleteContext';
export function canDeleteImportExport(): boolean {
return true;
}
export function collectImportExportDeleteImpact(importExport: ImportExport, context: DeleteImpactContext): void {
const key = 'importExport:' + importExport.id;
if (context.visited.has(key)) return;
context.visited.add(key);
const state = store.getState();
}
export function deleteImpactImportExport(importExport: ImportExport): DeleteImpact {
const context = deleteImpactContext();
collectImportExportDeleteImpact(importExport, context);
return deleteImpactCounts(context);
}
export function deleteImportExport(importExport: ImportExport, mergeId?: string, cascade?: DeleteTraversal): DeleteResult {
if (!cascade) {
if (!canDeleteImportExport()) return {status: 'notReady', impacts: []};
const context = deleteImpactContext();
collectImportExportDeleteImpact(importExport, context);
if (context.blocked) return {status: 'blocked', impacts: deleteImpactCounts(context)};
cascade = {visited: new Set(), importSource: mergeId ? 'merge' : 'delete', importId: mergeId || importExport.id};
}
const key = 'importExport:' + importExport.id;
if (cascade.visited.has(key)) return {status: 'deleted', impacts: []};
cascade.visited.add(key);
const targetImportSource = cascade.importSource;
mergeId = cascade.importId;
const _work = workingSet();
const dispatch = (action: any, key: string) => enqueueDelete(_work, onQueued => store.dispatch({...action, onQueued: (saved: boolean) => onQueued(saved, action.type.endsWith('_REMOVE_QUEUE'))}), () => _work.delete(key));

const deleted = importExport.clone();
deleted.status = 'D';
deleted.addedOn = newHRTimestamp();
deleted.addedBy = getCurrentUserId();
deleted.importSource = targetImportSource;
deleted.importId = mergeId;
_work.set(key, deleted);
const completion = dispatch(Actions.ImportExportActions.removeImportExportQueue(deleted), key);
return {status: 'deleted', impacts: [], completion};
}
